/**
 * This is app script.js file
 */

import Loader from '@/components/loader';

export default {
    name: 'app',
    components: {
        Loader
    },
    watch: {
        $route: {
            /**
             * @override
             */
            handler(route) {
                const _route = {
                    name: route.name,
                    params: route.params,
                    query: route.query
                };
                if (route.meta.isDetail) {
                    const item = {
                        route: _route,
                        active: true
                    };
                    this.$store
                        .dispatch('yuriMenuStore/disableItemsMenu')
                        .then(() => {
                            this.$store.dispatch('yuriMenuStore/upsertItem', item);
                            this.$store.dispatch('yuriMenuStore/setActiveItem', item);
                        });
                } else if (route.meta.isView) {
                    const subitem = {
                        name: route.query.name,
                        route: _route,
                        active: true
                    };
                    const index = this.$store.getters['yuriMenuStore/activeItem'];
                    this.$store.dispatch('yuriMenuStore/upsertSubItem', { subitem, index });
                }
            }
        }
    },
    /**
     * @override
     */
    created() {
        this.$store.dispatch('yuriMenuStore/loadSavedData');
    },
    computed: {
        /**
         * @override
         */
        isVisible() {
            return this.$store.getters['loaderStore/isVisible'];
        }
    }
};
